// V1-COMPAT: this tree was renamed from `companies/` to `companies_v1/` so the
// ported V2 companies components can live at the canonical `companies/` path.
import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../error_boundary_v1';
import CompanyShow from './show';
import { CompanyContextProvider } from './data/company_context_management';

function TopLevelShow({ companyId, userId }) {
  return (
    <CompanyContextProvider>
      <ErrorBoundary>
        <CompanyShow companyId={companyId} userId={userId} />
      </ErrorBoundary>
    </CompanyContextProvider>
  );
}

TopLevelShow.propTypes = {
  companyId: PropTypes.string.isRequired,
  userId: PropTypes.string,
};

TopLevelShow.defaultProps = {
  userId: undefined,
};

export default TopLevelShow;
